module.exports = __webpack_public_path__ + "img/bg1@2x.9ccc1e56.png";